import React, { useEffect, useState } from 'react';
import { ACTION_CODE, callApp } from '../../utils/callApp';
import { PAGREE_CODE } from '../../utils/codeEnum';
import './index.css';



const Announcement:React.FC<{data:any,onClose:Function}> = (props)=> {
  // setTimeout(()=>{
  //   props.onClose();
  // },2000)
  useEffect(()=>{
    
  },[])
  //展示状态
  const onClose = ()=>{
    //通知取消
    callApp(ACTION_CODE.POST_ANNOUNCEMENT,{code:PAGREE_CODE.SUCCESS})
    props.onClose();
  }
  const onSure = ()=>{
    callApp(ACTION_CODE.POST_CONFIRM,{code:PAGREE_CODE.CANCEL})
    props.onClose();
  }
  return (
    <>
      <div className="wrap_border">
        <div className="announcement_wrap">
          {props.data.announcementSupportOff&& <div className="announcement_close" onClick={()=>{onClose()}}></div>}
          <div className="announcement_title">系统公告</div>
          <div className="announcement_content">{props.data.announcementContext}</div>
        </div>
      </div>
    </>
  );
}




export default Announcement;
